import styled from 'styled-components';

import { WEDO_DEFAULT_WIDTH } from '~/styles/breakpoints';
import colors from '~/styles/colors';
import grid from '~/styles/grid';

export const Container = styled.div`
  background: white;
  box-shadow: 0px 3px 6px #00000029;
  left: 0;
  position: fixed;
  top: 80px;
  width: 100vw;
  z-index: 1000;
`;

export const Content = styled.div`
  font-size: 1rem;
  margin: ${grid.sm} auto;
  max-width: ${WEDO_DEFAULT_WIDTH};
  width: 100%;
`;

export const Button = styled.div`
  color: ${colors.primary};
  cursor: pointer;
  display: flex;
  gap: ${grid.xs};
`;
